import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  HandlersProgramDeliverableTypeResponse,
  useLazyGetApiProgramsDeliverableTypesQuery,
} from '../../app/athenaApiGen';

type TProgramDeliverableTypesFilterProps = {
  handleChange: (id?: string | null) => void;
  programDeliverableTypeId: string;
  required?: boolean;
};

const ProgramDeliverableTypesFilter = (
  props: TProgramDeliverableTypesFilterProps,
) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<
    HandlersProgramDeliverableTypeResponse[]
  >([]);
  const [queryDeliverableProgramTypes, { isFetching: isLoading }] =
    useLazyGetApiProgramsDeliverableTypesQuery();

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const programs = await queryDeliverableProgramTypes({
          programId: '', //default to IMCS program
        }).unwrap();
        const FORM_BASED_TYPES = [
          'Consent to Purchase Form',
          'Problem Notification Report',
          'Request to Initiate Purchase Form',
          'Travel Authorization Request',
          'Trip Report',
        ];
        setOptions(programs.filter((p) => !FORM_BASED_TYPES.includes(p.deliverableType?.title ?? '')));
      } catch (err) {
        console.log(err);
      }
    })();
  }, [queryDeliverableProgramTypes]);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Autocomplete
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        isOptionEqualToValue={(option, value) =>
          option.deliverableType?.title === value.deliverableType?.title
        }
        getOptionLabel={(option) => option.deliverableType?.title ?? ''}
        options={options}
        loading={isLoading}
        onChange={(_, newValue) => {
          props.handleChange(newValue ? newValue?.deliverableTypeId : null);
        }}
        value={
          options.find(
            (opt) => opt.deliverableTypeId === props.programDeliverableTypeId,
          ) || null
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Deliverable Type"
            required={props.required}
            size="small"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default ProgramDeliverableTypesFilter;
